import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "ceil",
  standalone: true
})
export class CeilPipe implements PipeTransform {
  transform(value: number): number {
    return isNaN(value) ? 0 : Math.ceil(value);
  }
}
